/**
 * License Request.
 *
 * @group DRM
 *
 * @beta
 */
export const LICENSE_REQUEST = 'license-request';
//# sourceMappingURL=LICENSE_REQUEST.js.map